export default __webpack_public_path__ + "static/media/portfolio.02901389.png";